import Image from 'next/image'

interface Props {
  src: string
  alt: string
  rotate?: number
  width?: number
  priority?: boolean
}

export function PhoneMockup({ src, alt, rotate = 0, width = 220, priority = false }: Props) {
  return (
    <div
      style={{
        position: 'relative',
        width,
        flexShrink: 0,
        transform: `rotate(${rotate}deg)`,
        filter: 'drop-shadow(0 32px 72px rgba(0,0,0,0.32))',
        margin: '0 auto',
      }}
    >
      <div
        style={{
          background: '#0A1A10',
          borderRadius: 36,
          padding: '10px 8px 14px',
          border: '1px solid rgba(255,255,255,0.06)',
          position: 'relative',
        }}
      >
        {/* Dynamic Island */}
        <div
          style={{
            position: 'absolute',
            top: 14,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 72,
            height: 20,
            background: '#0A1A10',
            borderRadius: 12,
            zIndex: 2,
          }}
        />

        {/* Tela */}
        <div style={{ borderRadius: 28, overflow: 'hidden', position: 'relative' }}>
          <Image
            src={src}
            alt={alt}
            width={width - 16}
            height={Math.round((width - 16) * 2.16)}
            sizes={`${width}px`}
            priority={priority}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        </div>

        {/* Barra inferior */}
        <div
          style={{
            width: 100,
            height: 4,
            background: 'rgba(255,255,255,0.15)',
            borderRadius: 4,
            margin: '10px auto 0',
          }}
        />
      </div>
    </div>
  )
}
